// Required parts

// The HugeRTE global. This must be before other HugeRTE imports.
import hugerte from "hugerte";

// // The following imports can be in any order.

// // The DOM model
// import "hugerte/models/dom";

// // The default icons. This is required, but you can import custom icons after it.
// import "hugerte/icons/default";

// // The silver theme. Customization of the look and feel of HugeRTE should be done by custom skins while still using the silver theme.
// import "hugerte/themes/silver";

// // The oxide skin (or you can use a custom one).
// import "hugerte/skins/ui/oxide/skin.js";
// import "hugerte/skins/ui/oxide-dark/skin.js";

// // The content skin provided by oxide (or a different skin you're using).
// import "hugerte/skins/ui/oxide/content.js";
// import "hugerte/skins/ui/oxide-dark/content.js";

// // The default content CSS. This can also be replaced by a custom file if needed.
// import "hugerte/skins/content/default/content.js";

// // Plugins are optional
// // This should correspond to your `plugins` config in the object passed to `hugerte.init()`.
// import "hugerte/plugins/accordion";
// import "hugerte/plugins/advlist";
// import "hugerte/plugins/anchor";
// import "hugerte/plugins/autolink";
// import "hugerte/plugins/autoresize";
// import "hugerte/plugins/autosave";
// import "hugerte/plugins/charmap";
// import "hugerte/plugins/code";
// import "hugerte/plugins/codesample";
// import "hugerte/plugins/directionality";
// import "hugerte/plugins/fullscreen";
// import "hugerte/plugins/image";
// // We'll have to investigate before recommending to use this one: https://github.com/hugerte/hugerte/issues/24
// import "hugerte/plugins/importcss";
// import "hugerte/plugins/insertdatetime";
// import "hugerte/plugins/link";
// import "hugerte/plugins/lists";
// import "hugerte/plugins/media";
// import "hugerte/plugins/nonbreaking";
// import "hugerte/plugins/pagebreak";
// import "hugerte/plugins/preview";
// import "hugerte/plugins/quickbars";
// import "hugerte/plugins/save";
// import "hugerte/plugins/searchreplace";
// import "hugerte/plugins/table";
// import "hugerte/plugins/template";
// import "hugerte/plugins/visualblocks";
// import "hugerte/plugins/visualchars";
// import "hugerte/plugins/wordcount";
// // import "hugerte/plugins/noneditable";

// // NOTE: For the emoticons plugin, you'll need two imports:
// import "hugerte/plugins/emoticons";
// import "hugerte/plugins/emoticons/js/emojis";

// // NOTE: For the help plugin, you'll need to import the localized keyboard navigation help
// // even if it's in english.
// import "hugerte/plugins/help";
// import "hugerte/plugins/help/js/i18n/keynav/es.js";
// // Whichever languages you need...
// // import "hugerte/plugins/help/js/i18n/keynav/de.js";

// In the `hugerte.init({})` call, set `skin_url` and `content_css` to `default` to make sure the bundled ones are used.
export default hugerte;

var tinymce = hugerte;
window.tinymce = hugerte;

var tinymceGlobalConfig = tinymceGlobalConfig || {};
function initTinyMCEEditor(element, globalConfig = tinymceGlobalConfig) {
  const baseConfig = {
    target: element,
    language: "es_MX",
    language_url: "/static/js/es_MX.js",
    height: "80vh",
    base_url: "https://cdn.jsdelivr.net/npm/hugerte@1/",
    plugins: [
      "emoticons",
      // "print",
      "preview",
      // "paste",
      "importcss",
      "searchreplace",
      "autolink",
      "autosave",
      "save",
      "directionality",
      "code",
      "visualblocks",
      "visualchars",
      "fullscreen",
      "image",
      "link",
      "media",
      "codesample",
      "table",
      "charmap",
      // "hr",
      "pagebreak",
      "nonbreaking",
      "anchor",
      // "toc",
      "insertdatetime",
      "advlist",
      "lists",
      "wordcount",
      // "imagetools",
      // "textpattern",
      // "noneditable",
      "help",
      "charmap",
      "quickbars",
      "emoticons",
    ].join(" "),
    imagetools_cors_hosts: ["picsum.photos"],
    menubar: "file edit view insert format tools table help",
    toolbar: [
      "undo redo | bold italic underline strikethrough",
      "fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent",
      "numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons",
      "fullscreen preview save print | insertfile image media template link anchor codesample | ltr rtl",
      "restoredraft | emoticons | customVideoChat",
    ].join(" | "),

    skin: "oxide",
    // content_css: "dark",
    toolbar_sticky: false,
    autosave_ask_before_unload: true,
    autosave_interval: "15s",
    autosave_prefix: "{path}{query}-{id}-",
    autosave_restore_when_empty: false,
    autosave_retention: "30m",
    image_advtab: true,
    importcss_append: true,
    image_caption: true,
    quickbars_selection_toolbar:
      "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
    noneditable_noneditable_class: "mceNonEditable",
    toolbar_mode: "wrap",
    contextmenu: "link image imagetools media",
  };

  if (document.firstElementChild.dataset.bsTheme === "dark") {
    baseConfig.skin = "oxide-dark";
    baseConfig.content_css = "dark";
  }

  if (element.dataset?.editorMode === "basic") {
    Object.assign(baseConfig, {
      height: "200px",
      toolbar:
        "bold italic underline strikethrough | forecolor backcolor | link | emoticons | selectItem",
      // toolbar_location: "top",
      menubar: false,
      width: "100%",
      statusbar: false,
      plugins: "emoticons image link media",
      contextmenu: "",
      toolbar_mode: "sliding",
    });
  } else if (element.dataset?.editorMode === "mail") {
    Object.assign(baseConfig, {
      menubar: false,
      width: "100%",
      statusbar: false,
    });
  }

  // Optional: override with globalConfig
  const finalConfig = Object.assign({}, baseConfig, globalConfig);

  // Add custom setup for the editor
  finalConfig.setup = function (editor) {
    if (typeof ICADE_DOCENTE_ROOM !== "undefined") {
      const iconSource =
        '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="video" width="16" height="16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"></path></svg>';
      editor.ui.registry.addIcon("insert-video", iconSource);
      editor.ui.registry.addButton("customVideoChat", {
        icon: "insert-video",
        onAction: function () {
          const markup = `
                        <table style="background: rgb(249,238,190); border: 1px solid #666;">
                            <tr>
                                <td style="padding: 5px">
                                    <a href="${ICADE_DOCENTE_ROOM}" target="_blank">
                                        <img src="data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJ2aWRlbyIgY2xhc3M9InN2Zy1pbmxpbmUtLWZhIGZhLXZpZGVvIGZhLXctMTgiIHJvbGU9ImltZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNTc2IDUxMiI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMzM2LjIgNjRINDcuOEMyMS40IDY0IDAgODUuNCAwIDExMS44djI4OC40QzAgNDI2LjYgMjEuNCA0NDggNDcuOCA0NDhoMjg4LjRjMjYuNCAwIDQ3LjgtMjEuNCA0Ny44LTQ3LjhWMTExLjhjMC0yNi40LTIxLjQtNDcuOC00Ny44LTQ3Ljh6bTE4OS40IDM3LjdMNDE2IDE3Ny4zdjE1Ny40bDEwOS42IDc1LjVjMjEuMiAxNC42IDUwLjQtLjMgNTAuNC0yNS44VjEyNy41YzAtMjUuNC0yOS4xLTQwLjQtNTAuNC0yNS44eiI+PC9wYXRoPjwvc3ZnPg==" width="32" height="32">
                                    </a>
                                </td>
                                <td style="padding: 5px">
                                    <span class="video-date-placeholder">[Inserte aqui la fecha y hora]</span><br>
                                    <a href="${ICADE_DOCENTE_ROOM}" target="_blank">Acceder al encuentro por videollamada</a>
                                </td>
                            </tr>
                        </table>`;
          editor.execCommand("mceInsertContent", false, markup);
          editor.focus();
          const placeholder = editor
            .getBody()
            .querySelector(".video-date-placeholder");
          if (placeholder) editor.selection.select(placeholder, true);
        },
      });
    }
  };

  tinymce.init(finalConfig);
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(`[name=content],.wysiwyg`).forEach((element) => {
    initTinyMCEEditor(element);
  });
});
